export enum TextTrackMode {
    Hidden = 'hidden',
    Showing = 'showing',
    Disabled = 'disabled'
}
